var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmtp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2634_93726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2634_93726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 20C3.45 20 2.97933 19.8043 2.588 19.413C2.196 19.021 2 18.55 2 18V6C2 5.45 2.196 4.97933 2.588 4.588C2.97933 4.196 3.45 4 4 4H20C20.55 4 21.021 4.196 21.413 4.588C21.8043 4.97933 22 5.45 22 6V11.7C21.7 11.55 21.3793 11.425 21.038 11.325C20.696 11.225 20.35 11.15 20 11.1V8L12.525 12.675C12.4417 12.725 12.354 12.7623 12.262 12.787C12.1707 12.8123 12.0833 12.825 12 12.825C11.9167 12.825 11.8293 12.8123 11.738 12.787C11.646 12.7623 11.5583 12.725 11.475 12.675L4 8V18H12C12 18.35 12.025 18.6873 12.075 19.012C12.125 19.3373 12.2 19.6667 12.3 20H4ZM12 11L20 6H4L12 11ZM19 23C17.6167 23 16.4377 22.5127 15.463 21.538C14.4877 20.5627 14 19.3833 14 18C14 16.6167 14.4877 15.4373 15.463 14.462C16.4377 13.4873 17.6167 13 19 13C20.3833 13 21.5627 13.4873 22.538 14.462C23.5127 15.4373 24 16.6167 24 18C24 19.3833 23.5127 20.5627 22.538 21.538C21.5627 22.5127 20.3833 23 19 23ZM16.5 18.5H21.5C21.6333 18.5 21.75 18.45 21.85 18.35C21.95 18.25 22 18.1333 22 18C22 17.8667 21.95 17.75 21.85 17.65C21.75 17.55 21.6333 17.5 21.5 17.5H16.5C16.3667 17.5 16.25 17.55 16.15 17.65C16.05 17.75 16 17.8667 16 18C16 18.1333 16.05 18.25 16.15 18.35C16.25 18.45 16.3667 18.5 16.5 18.5ZM4 18V11V11.075V8V8.25V6.8C4 6.61667 4 6.61667 4 6.8V6.787V8.25V8V18Z",
    fill: "#1F242F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmtp);
export default __webpack_public_path__ + "static/media/smtp.ce94dab3daf036d7d6df4e8419a33fb0.svg";
export { ForwardRef as ReactComponent };